<template>
  <div class="onls-datepicker__wrapper">
    <div v-if="label.length" class="field-label">{{ label }}</div>

    <div class="onls-datepicker">
      <datepicker
          v-model="modelValue"
          :upper-limit="maxDate"
          :lower-limit="minDate"
          :minimum-view="minimumView"
          :starting-view="startingView"
          :input-format="inputFormat"
      />

      <div v-if="clearable && !!modelValue" class="onls-datepicker__clear" @click="emits('update:value', null)">
        <svg xmlns="http://www.w3.org/2000/svg" width="10" height="10"><path d="M6.895455 5l2.842897-2.842898c.348864-.348863.348864-.914488 0-1.263636L9.106534.261648c-.348864-.348864-.914489-.348864-1.263636 0L5 3.104545 2.157102.261648c-.348863-.348864-.914488-.348864-1.263636 0L.261648.893466c-.348864.348864-.348864.914489 0 1.263636L3.104545 5 .261648 7.842898c-.348864.348863-.348864.914488 0 1.263636l.631818.631818c.348864.348864.914773.348864 1.263636 0L5 6.895455l2.842898 2.842897c.348863.348864.914772.348864 1.263636 0l.631818-.631818c.348864-.348864.348864-.914489 0-1.263636L6.895455 5z"></path></svg>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import Datepicker from 'vue3-datepicker'
import {computed, type PropType} from 'vue'

const props = defineProps({
  value: { type: Date, required: true },
  clearable: { type: Boolean, default: true },
  startingView: { type: String as PropType<"time" | "day" | "month" | "year">, default: 'day'},
  minimumView: { type: String as PropType<"time" | "day" | "month" | "year">, default: 'day'},
  maxDate: { type: Date },
  minDate: { type: Date },
  label: { type: String, default: "" },
  inputFormat: { type: String, default: 'yyyy-MM-dd'}
});

const emits = defineEmits(['update:value']);

const modelValue = computed({
  get() {
    return props.value;
  },
  set(value) {
    emits('update:value', value);
  }
});
</script>

<style lang="scss">
.onls-datepicker {
  position: relative;

  &__wrapper {
    width: 100%;
  }

  &__clear {
    position: absolute;
    top: 50%;
    right: 15px;
    transform: translateY(-50%);
    cursor: pointer;

    svg {
      path {
        fill: var(--primary-text);
      }
    }
  }

  .v3dp {
    &__datepicker {
      --vdp-bg-color: var(--primary-background);
      --vdp-text-color: var(--primary-text);
      --vdp-border-radius: 5px;
      --vdp-selected-color: var(--primary-background);
      --vdp-selected-bg-color: var(--primary-text);
      --vdp-divider-color: var(--primary-text);

      --vdp-hover-bg-color: var(--primary-text);
      --vdp-hover-color: var(--primary-background);
      --vdp-elem-font-size: 15px;
      --vdp-heading-hover-color: transparent;
      --vdp-heading-weight: 400;

      // possible to change
      //--vdp-heading-weight: bold;
      //--vdp-current-date-font-weight: bold;
      //"--vdp-heading-size": "2.5em",
      //"--vdp-arrow-color": "currentColor",
      //"--vdp-elem-color": "currentColor",
      //"--vdp-disabled-color": "#d5d9e0",
      //"--vdp-current-date-outline-color": "#888888",
      //"--vdp-elem-border-radius": "3px",

    }

    &__heading,
    &__subheading {
      margin-top: 0 !important;
      background: var(--secondary-background) !important;
    }

    &__heading {
      padding: 20px 0;
      height: auto !important;

      &__center {
        text-transform: uppercase !important;
      }
    }

    &__subheading {
      padding-bottom: 10px;
    }

    &__popout {
      border: 2px solid var(--primary-text);
      padding: 0 0 5px !important;
      margin-top: 10px;
    }
  }

  input {
    padding: 15px 20px;
    border: 2px solid var(--secondary-text);
    border-radius: 5px;
    outline: none;
    font-size: 16px;
    background: inherit;
    color: var(--primary-text);
    width: 100%;

    &:not(:placeholder-shown) {
      border-color: var(--primary-text);
    }
  }
}

.dark-theme {
  .onls-datepicker {
    .v3dp__element_button__minute,
    .v3dp__element_button__hour {
      color: #ffffff;
    }
  }
}
</style>
